import { render } from "./Board.vue?vue&type=template&id=05905a7a&ts=true"
import script from "./Board.vue?vue&type=script&lang=ts"
export * from "./Board.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__